import React from 'react';
import PageLayout from '../../layouts/pagelayout';
import Accordion from '../../components/accordion';
import Commitment from '../../content/strategy/commitment';
import AugmentRRBase from '../../content/strategy/augment-rr-base';
import GrowthOpportunities from '../../content/strategy/growth-opportunities';
import OptimiseCapital from '../../content/strategy/optimise-capital';
import OperationalExcellence from '../../content/strategy/operational-excellence';
import SectionTitle from '../../components/section-title';
import BreadCrumb from '../../components/breadcrumb';
import ScrollPositionAnimation from '../../components/scrollpositionanimation';

const Strategy = () => {
  const sampleData = {
    accordion: [
      {
        id: 1,
        title: 'Commitment to the larger purpose with focus on world-class ESG performance',
        source: () => <Commitment />,
      },
      { id: 2, title: 'Augment our Reserves & Resources (R&R) Base', source: () => <AugmentRRBase /> },
      { id: 3, title: 'Delivering on growth opportunities', source: () => <GrowthOpportunities /> },
      {
        id: 4,
        title: 'Optimise capital allocation and maintain strong balance sheet',
        source: () => <OptimiseCapital />,
      },
      { id: 5, title: 'Operational excellence', source: () => <OperationalExcellence /> },
    ],
  };

  return (
    <PageLayout pageTitle="Vedanta - Strategic Framework" pageLink="/overview/strategic-framework">
      <div className="strategy-page-content">
        <BreadCrumb />
        <div className="section-inner">
          <ScrollPositionAnimation targetElement2="anim-two">
            <div className="bottom-to-top anim-two">
              <section className="strategy-banner">
                <SectionTitle
                  label="STRATEGIC FRAMEWORK"
                  lighttext="PROGRESSING ON"
                  boldtext="OUR GROWTH PATH"
                  iconimage="icon-growth.png"
                  alt="icon-growth"
                ></SectionTitle>
                <h6 className="boldtext content-title">STRATEGIC PRIORITY</h6>
              </section>
              <section className="strategy-page-accordion">
                <Accordion data={sampleData.accordion} />
              </section>
            </div>
          </ScrollPositionAnimation>
        </div>

        <div className="strategy-btm">
          <div className="img-view-text">Aerial shot of the alumina refinery at Lanjigarh</div>
        </div>
      </div>
    </PageLayout>
  );
};

export default Strategy;
